<template>
  <div style="background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 8px; padding: 15px; margin: 10px 0;">
    <p style="font-size: small; margin-bottom: 0;">
      <template v-if="currentLanguage === 'en'">
        <b>Note*: How to Search and Request Additional Photos (no additional cost)</b><br>
        &nbsp; &nbsp;1. Upload your face photo to search and choose the unlimited package<br>
        &nbsp;2. Fill in your phone number, select a payment method, create the order, and complete the payment.<br>
        &nbsp;<b>3. For searching additional photos, such as underwater photos, action shots, or photos without visible faces, after you have purchased the unlimited package:</b><br>
        &nbsp;&nbsp;&nbsp;&nbsp; 3.1. Search for additional photos: Click the "Search photos manually" button, select the competition time period, and add the desired photos to your cart. Then create an order for "Request additional photos after unlimited purchase"<br>
        &nbsp;&nbsp;&nbsp;&nbsp; 3.2. Notify admin: Contact the admin for approval. Once approved, you will be able to download additional photos immediately.
          <b>You can learn how to search for additional photos here <a href="/how-to-get-additional-images" target="_blank" style="color: #007bff; text-decoration: none;">How to get additional images</a></b>
      </template>
      <template v-else>
        <b>Note*: วิธีการค้นหาและขอรูปภาพเพิ่มเติม (ไม่เสียค่าใช้จ่าย)</b><br>
        &nbsp;1. อัปโหลดภาพใบหน้าเพื่อค้นหา และเลือกแพ็กเกจเหมาๆ <br>
        &nbsp;2. กรอกเบอร์โทรศัพท์ เลือกช่องทางการชำระเงิน จากนั้นสร้างออร์เดอร์และชำระเงินให้เรียบร้อย<br>
        &nbsp;<b>3. เมื่อต้องการค้นหารูปภาพเพิ่มเติม เช่น ภาพใต้น้ำ ภาพต่อสู้ หรือภาพที่ไม่เห็นใบหน้า หลังจากสั่งซื้อแพ็กเกจเหมาๆ แล้ว:</b><br>
        &nbsp;&nbsp;&nbsp; 3.1. ค้นหาภาพเพิ่มเติม: กดปุ่ม "ค้นหารูปภาพด้วยตนเอง" เลือกช่วงเวลาที่แข่งขัน เลือกรูปที่ต้องการ ใส่ตะกร้า และสร้างออร์เดอร์ใหม่ โดยเลือกเมนู "ขอรูปเพิ่มเติมหลังจากเหมาไปแล้ว"<br>
        &nbsp;&nbsp;&nbsp; 3.2. แจ้งแอดมิน: ติดต่อแอดมินเพื่อขออนุมัติ เมื่ออนุมัติแล้ว คุณจะสามารถดาวน์โหลดรูปภาพเพิ่มเติมได้ทันที<br><br>
         <b>สามารถศึกษาวิธีการค้นหารูปภาพเพิ่มเติมได้ที่นี่ <a href="/how-to-get-additional-images" target="_blank" style="color: #007bff; text-decoration: none;">วิธีการรับภาพเพิ่มเติม</a></b>
      </template>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ManualSearchNote',
  props: {
    currentLanguage: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
/* Component-specific styles can be added here if needed */
</style>
